<template lang="pug">
section.dsp-configuration
    ElTable.dsp-table.monitoring-table.cursor(
        row-key="id"
        current-row-key="id"
        :data="paginatedData",
        style="width:100%",
        :row-class-name="rowStyle"
        @row-click="handleRowClick"
        empty-text='No configuration available',
        :default-sort='{ order: sortOrder, prop: sortBy }',
        @sort-change="handleTableSort"
        :max-height="tableHeight")
        ElTableColumn(prop="partnerLabel" label="Partner" sortable)
            template(slot-scope="scope")
                div.full-width(:title="scope.row.partnerLabel")
                    p.is-truncate.partner-label {{ scope.row.partnerLabel }} 
                        svg-icon.cursor(v-if="displayWarning(scope.row)" name='warning-red' size='small')
        ElTableColumn(prop="dsp_client_id" label="Identifier" sortable)
            template(slot-scope="scope")
                div.full-width(:title="scope.row.dsp_client_id")
                    p.is-truncate {{ scope.row.dsp_client_id }}
        ElTableColumn(prop="label" label="Label" sortable)
            template(slot-scope="scope")
                div.full-width(:title="scope.row.label")
                    p.is-truncate {{ scope.row.label }}
        ElTableColumn(width="50")
            template(slot-scope="scope")
                .actions-delete(@click.prevent="deleteConfigHandler(scope.row.id)")
                    svg-icon(name='trash' size='small' title="Delete")
        
    ElPagination(
        background,
        layout='prev, pager, next, sizes',
        :total='configurations.length',
        :page-size.sync='pageSize',
        :current-page.sync='currentPage',
        :page-sizes='[5, 10, 25, 50, 100]'
)
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    props: {
        configurations: { type: Array, required: true }
    },

    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            sortOrder: null,
            defaultSortOrder: null,
            sortBy: 'partnerLabel',
            isSorted: false,
            sortedData: [],
            rowIsActive: false,
        }
    },

    computed: {
        ...mapState('ui/dsp', {
            selectedDspConfigurationId: state => state.selectedRowId,
            selectedDsp: state => state.selectedDsp
        }),
        paginatedData() {
            return this.paginate(this.isSorted ? this.sortedData : this.configurations)
        },
        tableHeight() {
            return window.innerHeight - 350
        }
    },
    watch: {
        configurations: {
            handler: function(values) {
                if (this.isSorted) {
                    this.sortedData =  [...values].sort(this.sortingData(this.sortBy, this.sortOrder))
                }
            },
            deep: true
        },
        selectedDspConfigurationId: {
            handler: function(value) {
                if (value) this.rowStyle({id: value})
            },
            deep: true,
        },
    },

    methods: {
        ...mapMutations('ui/dsp', ['setSelectedRow', 'setDisplayModal', 'setDeletedConfig']),
        ...mapActions('data/transfer', ['retrieveAccountsDspActiveTransfers']),

        paginate(rows) {
            const trimStart = (this.currentPage - 1) * this.pageSize
            const trimEnd = trimStart + this.pageSize
            return rows.slice(trimStart, trimEnd)
        },

        sortByColumn(sortBy) {
            return (a, b) => b[sortBy] - a[sortBy]
        },

        sortingData(sortBy, order) {
            // asc order
            if (order === 'ascending') return (a, b) => typeof a[sortBy] == 'string'
                ? a[sortBy].toLowerCase().localeCompare(b[sortBy].toLowerCase(), 'en') : a[sortBy] - b[sortBy]
            // desc order
            return (a, b) => typeof a[sortBy] == 'string'
                ? b[sortBy].toLowerCase().localeCompare(a[sortBy].toLowerCase(), 'en') : b[sortBy] - a[sortBy]
        },

        handleTableSort({ _, prop, order }) {
            this.sortBy = prop
            this.sortOrder = order
            // use default sort if order is null
            if (!order) this.isSorted = false
            else {
                // to ovoid infinite loop we clone configuration
                this.sortedData =  [...this.configurations].sort(this.sortingData(prop, order))
                this.isSorted = true
            } 
        },

        handleRowClick({ id }) {
            if (id === this.selectedDspConfigurationId) {
                this.setSelectedRow({ rowId: null })
            } else {
                this.setSelectedRow({ rowId: id })
            }
        },

        rowStyle({ row }) {
            if (row?.id === this.selectedDspConfigurationId) return 'selected-row-partner'
        },


        deleteConfigHandler(id) {
            const params = { accounts_dsp_id: id }
            this.retrieveAccountsDspActiveTransfers(params).then(() => {
                this.setDisplayModal({ item: 'confirmation', display: true })
                this.setDeletedConfig({ id })
            })
        },

        displayWarning(row) {
            return row.partnerKey === 'tiktok' && !JSON.parse(row.extra_info).is_authenticated
        }
    }
}
</script>
<style lang="scss">
.dsp-table.monitoring-table {
    .partner-label {
        display: flex;

        .icon-wrapper {
            margin-left: 8px;
        }
    }
}
</style>
